export const BookmarkTypes = ['job', 'volunteering', 'article', 'course', 'traveldeal'] as const
export type BookmarkType = typeof BookmarkTypes[number]